import { Badge } from '@/components/ui/badge';
import { cn } from '@/components/ui/utils';

interface Props {
  tier: string | null;
  size?: 'sm' | 'md';
}

function tierLabel(tier: string | null): string {
  if (!tier) return '?';
  const letter = tier.charAt(0).toUpperCase();
  return letter;
}

function tierColor(tier: string | null): string {
  const letter = tier?.charAt(0).toUpperCase();
  switch (letter) {
    case 'A': return 'bg-success/15 text-success border-success/30';
    case 'B': return 'bg-info/15 text-info border-info/30';
    case 'C': return 'bg-warning/15 text-warning border-warning/30';
    case 'D': return 'bg-primary/15 text-primary border-primary/30';
    case 'F': return 'bg-muted text-muted-foreground border-border';
    default: return 'bg-muted text-muted-foreground border-border';
  }
}

export function ProspectTierBadge({ tier, size = 'sm' }: Props) {
  return (
    <span
      className={cn(
        'inline-flex items-center justify-center rounded-full font-bold border',
        tierColor(tier),
        size === 'sm' ? 'h-6 w-6 text-xs' : 'h-8 w-8 text-sm'
      )}
      title={tier ?? 'Unknown tier'}
    >
      {tierLabel(tier)}
    </span>
  );
}

export function ProspectStatusBadge({ status }: { status: string }) {
  const map: Record<string, string> = {
    prospect: 'bg-muted text-muted-foreground',
    deck_building: 'bg-primary/15 text-primary',
    deck_ready: 'bg-info/15 text-info',
    outreach_sent: 'bg-warning/15 text-warning',
    meeting_booked: 'bg-success/15 text-success',
    disqualified: 'bg-destructive/15 text-destructive',
  };
  const labels: Record<string, string> = {
    prospect: 'Prospect',
    deck_building: 'Deck Building',
    deck_ready: 'Deck Ready',
    outreach_sent: 'Outreach Sent',
    meeting_booked: 'Meeting Booked',
    disqualified: 'Disqualified',
  };
  return (
    <Badge variant="outline" className={cn('text-xs font-medium', map[status] ?? 'bg-muted text-muted-foreground')}>
      {labels[status] ?? status}
    </Badge>
  );
}
